import { AnalyticsAppEventData } from "client/Api/Analytics/analytics";
import { AppType } from "client/Api/Apps/common";
import { useAnalyticsStore } from "client/Features/Analytics/analyticsStore";
import { GlobalSearchItemPersistedModel } from "client/Features/Search/RecentSearch/Persistence/models";
import { useRecentlyOpenedResults } from "client/Features/Search/RecentSearch/Persistence/useRecentlyOpenedResults";
import { useCallback } from "react";
import {
	RecentlyOpenedItemConfigurationProps,
	useResolveRecentlyOpenedItemForPersistence
} from "./useResolveRecentlyOpenedItemForPersistence";
import { getHubUrlForAnnouncement } from "client/Features/Hub/Announcements/AnnouncementsPage";
import { HubDataSource } from "client/Api/Hub/hub";
import { navigateTo } from "client_legacy/ndaw/navigator";

export type AnnouncementNavigationHandlerProps = {
	id: number;
}
	& RecentlyOpenedItemConfigurationProps;

export function useAnnouncementNavigationHandler(props: AnnouncementNavigationHandlerProps): (() => void) {
	const {
		id
	} = props;

	const addAnalyticsAppEvent: (data: AnalyticsAppEventData) => void = useAnalyticsStore(x => x.addAppEvent);
	const { registerFromRecentlyOpened: registerRecentlyOpenedItem } = useRecentlyOpenedResults();

	const recentlyOpenedItem: GlobalSearchItemPersistedModel = useResolveRecentlyOpenedItemForPersistence(props);

	return useCallback(
		(): void => {
			addAnalyticsAppEvent({ appType: AppType.Hub });
			registerRecentlyOpenedItem(recentlyOpenedItem);
			navigateToAnnouncement(id);
		},
		[
			addAnalyticsAppEvent,
			id,
			recentlyOpenedItem,
			registerRecentlyOpenedItem
		]
	);
}

export function navigateToAnnouncement(announcementId: number): void {
	const url: string = getHubUrlForAnnouncement({
		source: HubDataSource.Announcement,
		itemId: announcementId
	});

	navigateTo(url);
}